import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import { useComponentState } from '#public_ts/composables';

import type { LowerPaneDetailsBuilder } from './lower-pane-details';
import TabPane from './tab/tab-pane.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'lower-pane-details',
  props: {
    row: null,
    builder: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
    row?: any;
    builder?: LowerPaneDetailsBuilder<any>;
    size?: 'normal' | 'wide';
}


const state = useComponentState({ id: 'LowerPaneDetails', initialUpdate: true });
const details = ref<[string, string][]>([]);

watch(() => props.row, () => {
    state.update();
});

state.onUpdate(() => {
    if(props.row && props.builder) {
        details.value = props.builder(props.row);
    }
});

return { __sfc: true,props, state, details, TabPane }
}

})